'use strict'

import RouterLink from './RouterLink.vue'

import {
  updateChangeHandler,
  updateLinkGenerator,
  updateState,
} from './service'

import {
  use,
  registerComponentProgrammatic,
  registerComponent,
} from '@akerolabs/akero-vue/src/utils/plugins'

const RouterLinkProgrammatic = {
  setHandler(handler, linkFn) {
    updateChangeHandler(handler)
    updateLinkGenerator(linkFn)
  },
  setState(state) {
    updateState(state)
  },
}

const Plugin = {
  install(Vue) {
    registerComponent(Vue, RouterLink)
    registerComponentProgrammatic(Vue, 'routerLink', RouterLinkProgrammatic)
  },
}

use(RouterLink)

export default Plugin
export { RouterLinkProgrammatic }
export { useRoute, useRouter } from './hooks'
export { default as RouterLink } from './RouterLink.vue'
